var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81 0.987793H13.191C16.28 0.987793 18 2.7463 18 5.75947V15.9647C18 19.0273 16.28 20.7463 13.191 20.7463H4.81C1.77 20.7463 0 19.0273 0 15.9647V5.75947C0 2.7463 1.77 0.987793 4.81 0.987793ZM5.08 5.59152V5.58165H8.069C8.5 5.58165 8.85 5.92742 8.85 6.35124C8.85 6.78691 8.5 7.13269 8.069 7.13269H5.08C4.649 7.13269 4.3 6.78691 4.3 6.36211C4.3 5.9373 4.649 5.59152 5.08 5.59152ZM5.08 11.5981H12.92C13.35 11.5981 13.7 11.2523 13.7 10.8275C13.7 10.4027 13.35 10.056 12.92 10.056H5.08C4.649 10.056 4.3 10.4027 4.3 10.8275C4.3 11.2523 4.649 11.5981 5.08 11.5981ZM5.08 16.1129H12.92C13.319 16.0734 13.62 15.7365 13.62 15.3423C13.62 14.9373 13.319 14.6014 12.92 14.5619H5.08C4.78 14.5322 4.49 14.6706 4.33 14.9274C4.17 15.1744 4.17 15.5004 4.33 15.7573C4.49 16.0043 4.78 16.1524 5.08 16.1129Z",
    fill: "#F7931A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIconActive);
export default __webpack_public_path__ + "static/media/account_icon_active.cfcddf25dbd7f64d9a15294483c1666f.svg";
export { ForwardRef as ReactComponent };